import { render, staticRenderFns } from "./MessagesSeparatorByDateNew.vue?vue&type=template&id=26f9f0ca&scoped=true"
import script from "./MessagesSeparatorByDateNew.vue?vue&type=script&lang=ts"
export * from "./MessagesSeparatorByDateNew.vue?vue&type=script&lang=ts"
import style0 from "./MessagesSeparatorByDateNew.vue?vue&type=style&index=0&id=26f9f0ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f9f0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f9f0ca')) {
      api.createRecord('26f9f0ca', component.options)
    } else {
      api.reload('26f9f0ca', component.options)
    }
    module.hot.accept("./MessagesSeparatorByDateNew.vue?vue&type=template&id=26f9f0ca&scoped=true", function () {
      api.rerender('26f9f0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/MessagesSeparatorByDateNew.vue"
export default component.exports